<div class="container">
	<div class="header">
		<div class="header__content">
			<h1>Terms and Conditions</h1>
		</div>
	</div>
</div>
<div class="container terms-and-conditions">
	<div class="body">
		<ol type="1">
			<li>
				<p class="fw-bold">Binding Agreement</p>
				<ol type="a">
					<li>
						<p>
							This Website is made available for use by individuals searching
							for employment opportunities at {{ customData.provenance }}; by
							Employees searching for potential Candidates for referral to
							Clients or employment at {{ customData.provenance }}; and for
							Clients searching for potential engagement into their accounts
							with {{ customData.provenance }}.
						</p>
					</li>
					<li>
						<p>
							This Website is provided to you for your use subject to these
							Terms that form a binding agreement between you and
							{{ customData.provenance }}. By accessing or using the Website you
							agree to accept and/or to be bound by these Terms.
						</p>
					</li>
					<li>
						<p>
							By accessing or using the {{ customData.url }} Website, you
							represent that you have read and understood the
							<a class="fw-medium" routerLink="/privacy-policy"
								>Privacy Policy</a
							>.
						</p>
					</li>
					<li>
						<p>
							In the case of any conflict between these Terms and any contract
							you have with {{ customData.provenance }}, these Terms will take
							precedent.
						</p>
					</li>
					<li>
						<p>
							We may update these Terms from time to time. The changes will
							apply to the use of the Website after due notice. If you do not
							wish to accept the new Terms you should not continue to use the
							Website. If you continue to use the Website after the date on
							which the change comes into effect, your use of the Website
							indicates your agreement to be bound by the new Terms.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Definitions</p>
				<ol type="a">
					<li>
						<p>
							<span class="fw-medium">Account</span> means the account
							authenticated by username and password, to access the Website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Account Holder</span> refers to any User
							who has registered for an Account on the Website or has access to
							the Website for the sole purpose of availing the Services.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Candidate</span> means a User who is
							accessing the Website to search for a job and create a Profile or
							in any other capacity except as an Employee or Client.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Client</span> means a person or entity
							that is accessing the Website and utilizing the Website for the
							exclusive purpose of seeking Candidates for engagement into their
							account or their clients.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">{{ customData.provenance }}</span> means
							{{ customData.provenance }} Pty Ltd or any related bodies
							corporate operating the Website in the country in which you live
							or in which {{ customData.provenance }} is headquartered.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Content</span> includes all text,
							graphics, design, programming, information, images, video, audio
							files, software and other contents used on the Website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Database</span> all jobs posted on the
							Website and/or all Candidates information registered on the
							Website including any Profile or resume.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Design</span> includes the color
							combinations and the page layout of the Website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Employee</span> means a person engaged or
							employed by {{ customData.provenance }}, which has or was given
							access to the Website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Graphics</span> includes all logos, button
							icons, and other graphical elements on the Website.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Profile</span> means the profile created
							by the Candidate that may include personal information, resume and
							photo.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Services</span> means any services
							provided by {{ customData.provenance }} through the Website, among
							others, include:
						</p>
						<ol type="i">
							<li>
								<p>
									the provision of online job site, including posting and
									searching for employment opportunities, and creating Profiles,
									which may include personal information;
								</p>
							</li>
							<li>
								<p>
									the provision of talent sourcing service and matching of jobs
									specifications with a potential candidate;
								</p>
							</li>
							<li>
								<p>
									notification and updates of the job applications of
									Candidates; and
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							<span class="fw-medium">User</span> refers to any individual or
							entity that uses any aspect of the Website and/or the Services.
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">Website</span>
							{{ customData?.websiteMeans }}
						</p>
					</li>
					<li>
						<p>
							<span class="fw-medium">You</span> or
							<span class="fw-medium">your</span> means the person who (or the
							entity on behalf of whom you are acting) that is agreeing to these
							Terms.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Registration</p>
				<ol type="a">
					<li>
						<p>
							To register an Account on the Website you must be of legal age or
							above.
						</p>
					</li>
					<li>
						<p>
							You must ensure that the details provided by you on your
							registration or at any time are correct and complete.
						</p>
					</li>
					<li>
						<p>
							You must inform us immediately of any changes to the information
							that you provided when registering by updating your personal
							details in order that we can communicate with you effectively.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Password and Security</p>
				<ol type="a">
					<li>
						<p>
							When you register to use the Website you will be asked to create a
							password. In order to prevent fraud, you must keep this password
							confidential and must not disclose it or share it with anyone. If
							you know or suspect that someone else knows your password you
							should notify us by contacting us at
							<a class="fw-medium" [href]="customData?.mailToPrivacyEmail">{{
								customData?.privacyEmail
							}}</a>
							immediately.
						</p>
					</li>
					<li>
						<p>
							If {{ customData.provenance }} has reason to believe that there is
							likely to be a breach of security or misuse of the Website, we may
							require you to change your password or we may suspend your account
							immediately.
						</p>
					</li>
					<li>
						<p>
							You shall be strictly liable and/or responsible for all uses of
							your Account registrations and passwords, whether or not
							authorized by you.
						</p>
					</li>
					<li>
						<p>
							As a result of your loss of your password or the misuse of the
							Website:
						</p>
						<ol type="i">
							<li>
								<p>
									all losses or damages incurred thereby shall be borne by you;
									and
								</p>
							</li>
							<li>
								<p>
									you shall fully indemnify {{ customData.provenance }} should
									the Website suffer any loss, damage or payment of fine from
									any regulatory or legal authority.
								</p>
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Intellectual Property</p>
				<ol type="a">
					<li>
						<p>
							The Website, the Content, and all right, title and interest
							thereto are the exclusive property of
							{{ customData.provenance }} and are protected by copyright, trade
							mark, database right and other intellectual property rights.
						</p>
					</li>
					<li>
						<p>
							You may retrieve and display any Content of the Website on a
							computer screen, store such content in electronic form on disk
							(but not any server or other storage device connected to a
							network) or print one copy of such content for your own personal,
							non-commercial use, provided you keep intact all and any copyright
							and proprietary notices. You may not otherwise reproduce, modify,
							copy or distribute or use for commercial or other purposes any of
							the materials or Content on the Website without written permission
							from {{ customData.provenance }}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Availability of the Website</p>
				<ol type="a">
					<li>
						<p>
							Although we aim to offer you the best service possible, we make no
							promise that the services at the Website will meet your
							requirements and full satisfaction.
						</p>
					</li>
					<li>
						<p>
							We cannot guarantee that the Website will be fault-free,
							error-free, or that the Website and servers are free of viruses or
							other harmful mechanisms. If a fault occurs with the Website, you
							should report it at

							<a class="fw-medium" [href]="customData?.mailToRecruiterEmail">{{
								customData.recruitEmail
							}}</a>
							and we will attempt to correct the fault as soon as we can.
						</p>
					</li>
					<li>
						<p>
							Your access to the Website may be occasionally restricted and the
							Service may be unavailable in order to allow for repairs,
							maintenance or the introduction of new content, facilities or
							services. We will attempt to restore access and/or service as soon
							as we reasonably can.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may terminate, suspend, update, alter
							or supplement, at its sole discretion, all or any part of the
							Website at any time. By permitting access to the Website,
							{{ customData.provenance }} does not convey any interest in or to
							the Content or any other {{ customData.provenance }} property or
							Services. All right, interest in and to the Website is and shall
							remain in {{ customData.provenance }}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Your Use of the Website</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} hereby grants you a limited,
							terminable, non-exclusive right to access and use the Website.
						</p>
					</li>
					<li>
						<p>
							You shall use the Website as provided in these Terms, in any
							contract you have with {{ customData.provenance }} in compliance
							with all laws including laws governing personal data.
						</p>
					</li>
					<li>
						<p>
							You agree that you shall not disclose any Content, Profile,
							Database from the Website, unless with the written consent of
							{{ customData.provenance }}.
						</p>
					</li>
					<li>
						<p>
							You cannot sell or assign your rights or obligations under these
							Terms.
						</p>
					</li>
					<li>
						<p>
							You may not use the Website for any of the following purposes:
						</p>
						<ol type="i">
							<li>
								<p>
									disseminating any unlawful, harassing, libelous, abusive,
									threatening, harmful, vulgar, obscene, or otherwise
									objectionable material or otherwise breaching any laws;
								</p>
							</li>
							<li>
								<p>
									aggregating, copying or duplicating in any manner any of the
									Content, Profile, Database or any information available from
									the Website, including expired/archived job postings;
								</p>
							</li>
							<li>
								<p>
									reproducing any of the Content, Profile, Database or any
									information available on the Website for general or commercial
									use;
								</p>
							</li>
							<li>
								<p>
									transmitting material that encourages the conduct that
									constitutes a criminal offense, or otherwise breaches any
									applicable laws, regulations or code of practice;
								</p>
							</li>
							<li>
								<p>
									interfering with any other person’s use or enjoyment of the
									Website; or
								</p>
							</li>
							<li>
								<p>
									making, transmitting or storing electronic copies of materials
									protected by copyright or any forms of intellectual property
									rights without the permission of the owner or
									{{ customData.provenance }}.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							In order to ensure a safe and effective experience,
							{{ customData.provenance }}
							reserves the right to limit the amount of data (including Content,
							Profile and Database views) that may be accessed by or provided to
							you in any given time period. These limits may be amended at
							{{ customData.provenance }}'s sole discretion from time to time.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may reformat the Content as
							{{ customData.provenance }} sees fit.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Your Use of the Services</p>
				<ol type="a">
					<li>
						<p>The Services may be used only by:</p>
						<ol type="i">
							<li>
								<p>
									Candidates seeking employment, and career and career-related
									information at {{ customData.provenance }};
								</p>
							</li>
							<li>
								<p>
									Employees seeking potential Candidates for referral to
									Clients;
								</p>
							</li>
							<li>
								<p>
									Employees seeking potential Candidates for employment at
									{{ customData.provenance }}; and
								</p>
							</li>
							<li>
								<p>
									Clients seeking potential candidates for engagement in their
									account or client.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							Your use of the Services is also subject to any other contracts
							you may have with {{ customData.provenance }}. In the case of any
							conflict between these Terms and any contract you have with
							{{ customData.provenance }}, these Terms will prevail.
						</p>
					</li>
					<li>
						<p>All Users agree to not:</p>
						<ol type="i">
							<li>
								<p>
									transmit, post, distribute, store or destroy material,
									including without limitation Content, Profile, Database, in
									violation of any applicable law or regulation, including but
									not limited to laws or regulations governing the collection,
									processing, or transfer of personal information, or in breach
									of {{ customData.provenance }}
									<a class="fw-medium" routerLink="/privacy-policy"
										>Privacy Policy</a
									>;
								</p>
							</li>
							<li>
								<p>
									violate or attempt to violate the security of the Website;
								</p>
							</li>
							<li>
								<p>reverse engineer or decompile any parts of the Website;</p>
							</li>
							<li>
								<p>
									aggregate, copy or duplicate in any matter any of the Content,
									Profile, Database or information available from any Website,
									including expired job postings, other than as permitted by
									these Terms;
								</p>
							</li>
							<li>
								<p>
									share with a third party any login credentials to the Website;
								</p>
							</li>
							<li>
								<p>
									access data not intended for you or logging into a server or
									account which you are not authorized to access;
								</p>
							</li>
							<li>
								<p>
									post content that contains restricted or password-only access
									pages, or hidden pages or images;
								</p>
							</li>
							<li>
								<p>
									solicit passwords or personally identifiable information from
									other Users;
								</p>
							</li>
							<li>
								<p>
									delete or alter any material posted by any other person or
									entity;
								</p>
							</li>
							<li>
								<p>
									send unsolicited mail or email, make unsolicited phone calls
									or send unsolicited messages promoting and/or advertising
									products or services to any User, or contact any users that
									have specifically requested not to be contacted by you;
								</p>
							</li>
							<li>
								<p>
									attempt to interfere with service to any User, host or
									network, including, without limitation, via means of
									submitting a virus to the Website, overloading, “flooding”,
									“spamming”, “mailbombing”, or “crashing”.
								</p>
							</li>
							<li>
								<p>
									use the Services for any unlawful purpose or illegal activity,
									or post or submit any content, profile, resume, or job posting
									that is defamatory, libelous, implicitly or explicitly
									offensive, vulgar, obscene, threatening, harassing, abusive,
									hateful, racist, discriminatory, of a menacing character or
									likely to cause annoyance, inconvenience, embarrassment,
									anxiety or could cause harassment to any person or include any
									links to pornographic, indecent or sexually explicit material
									of any kind, as determined by {{ customData.provenance }}’s
									discretion.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							Violations of network security may result in civil and/or criminal
							liability. {{ customData.provenance }} will investigate
							occurrences which may involve such violations and may involve, and
							cooperate with, law enforcement authorities in prosecuting Users
							who are involved in such violations.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Additional Terms Applicable to Employees</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} hereby grants you a limited,
							terminable, non-exclusive right to access and use the Website in
							seeking candidates for engagement for referral to Clients or
							employment at {{ customData.provenance }}. This authorizes you to
							view and download the Content, Profile or materials from the
							Website solely for your use directly related to searching for
							Candidates.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} also grants you a limited, terminable,
							non-exclusive right to use the Services for your employment use
							only at {{ customData.provenance }}.
						</p>
					</li>
					<li>
						<p>
							You are responsible for maintaining the confidentiality of your
							Account, profile and passwords, as applicable and shall be
							surrendered or automatically be terminated upon severance of your
							employment with {{ customData.provenance }}.
						</p>
					</li>
					<li>
						<p>
							You shall take appropriate physical, technical, and administrative
							measures to protect the data you have obtained from the Website
							from loss, misuse, unauthorized access, disclosure alteration or
							destruction.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Additional Terms Applicable to Clients</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} hereby grants you a limited,
							terminable, non-exclusive right to access and use
							{{ customData.url }} Website for your internal use seeking
							candidates for engagement. This authorizes you to view and
							download a single copy of the Content or Profile on the Website
							solely for searching Candidates for potential engagement.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} also grants you a limited, terminable,
							non-exclusive right to use {{ customData.url }} Services for your
							internal company use only.
						</p>
					</li>
					<li>
						<p>
							You agree not to request or allow another person to create or use
							your Account on your behalf, for your use, or for your benefit,
							except that of an authorised employee or agent. You represent and
							warrant that: (a) the User is authorised to act on your behalf;
							and (b) you are fully responsible and liable for the User’s acts
							and omissions, including for obligations and liabilities under
							this Agreement. If any such User violates the Terms of this
							Agreement, it may affect your ability to use the Website and
							Services.
						</p>
					</li>
					<li>
						<p>
							You acknowledge and agree that you shall disregard any personal
							data received from the Candidate which are irrelevant to obtaining
							and assessing the suitability of candidates.
						</p>
					</li>
					<li>
						<p>
							You are solely responsible for the use of the Website.
							{{ customData.provenance }} shall not be responsible to you, for
							whatever reasons, in regards to your selection of Candidates
							posted on {{ customData.url }}
							Website.
						</p>
					</li>
					<li>
						<p>
							You shall use the Website as provided in these Terms, in any
							contract you have with {{ customData.provenance }} in compliance
							with all laws including laws governing personal data.
						</p>
					</li>
					<li>
						<p>
							You shall take appropriate physical, technical, and administrative
							measures to protect the data you have obtained from the Website
							from loss, misuse, unauthorized access, disclosure alteration or
							destruction.
						</p>
					</li>
					<li>
						<p>The {{ customData.url }} Website shall not be used:</p>
						<ol type="i">
							<li>
								<p>
									for any purpose other than as a Client seeking candidates for
									engagement; or
								</p>
							</li>
							<li>
								<p>
									to make unsolicited phone calls or faxes or send unsolicited
									mail, email, or newsletter to {{ customData.url }} Profile or
									resume holders or to contact any individual unless they have
									agreed to be contacted.
								</p>
							</li>
							<li>
								<p>
									to download or copy any {{ customData.url }} Content or create
									any derivative work thereof with the intent of creating your
									own database.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							The data obtained from the Content, Profile, Database or Website
							shall not be kept longer than is necessary for the fulfillment of
							the purposes set out in this Section. In this respect, you agree
							and undertake to delete, destroy and/or purge such data or any
							derivatives thereof from your records.
						</p>
					</li>
					<li>
						<p>
							You may not use Website in any way which, in
							{{ customData.provenance }}’s sole judgment, adversely affects
							{{ customData.provenance }}’s business, business prospects, the
							performance or function of any of {{ customData.url }}, or
							interferes with the ability of other subscribers to access the
							Website.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Additional Terms Applicable to Candidates</p>
				<ol type="a">
					<li>
						<p>
							By creating a Profile through the Website, you are requesting and
							authorizing {{ customData.provenance }} to make available your
							Profile or resume to {{ customData.provenance }}, the Employees,
							the Clients and its sub-clients, and other persons/entities that
							{{ customData.provenance }} believes may have an interest in your
							Profile.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} hereby grants you a limited,
							terminable, non-exclusive right to access and use the Website only
							for your personal use seeking employment opportunities for
							yourself.
						</p>
					</li>
					<li>
						<p>
							When you register on the Website, you will be asked to create an
							Account and provide {{ customData.provenance }} with certain
							information including a valid email address.
						</p>
					</li>
					<li>
						<p>
							Any Profile you create or submit must be accurate, complete, up to
							date and not misleading. The Profile requires standard fields to
							be completed by you. You may not impersonate another person,
							living or dead.
						</p>
					</li>
					<li>
						<p>
							You must not post or submit to the Website any inaccurate,
							incomplete, misleading, false, not up to date biographical
							information or information which is not your own;
						</p>
					</li>
					<li>
						<p>
							You must not post any Profile or resume which is not a genuine
							profile or resume and which attempts to advertise or promote
							products or services.
						</p>
					</li>
					<li>
						<p>
							You acknowledge and agree that you are solely responsible for the
							form, content and accuracy of your Profile and resume or material
							contained therein placed by you on the Website.
						</p>
					</li>
					<li>
						<p>
							You acknowledge and agree that you are solely responsible for any
							consequences arising from such posting.
						</p>
					</li>
					<li>
						<p>
							By creating your Profile on the Website, you are requesting and
							authorizing {{ customData.provenance }} to review your Profile and
							provide you with feedback, including suggested changes.
							{{ customData.provenance }} assumes no responsibility and
							disclaims any liability for any change that you make based on any
							provided feedback.
						</p>
					</li>
					<li>
						<p>
							It is your responsibility to review your Profile to ensure it
							contains the right information or any information you intend to
							include or update. If you see any inaccuracy, it is your
							responsibility to correct such information or to contact
							{{ customData.provenance }} to do so.
						</p>
					</li>
					<li>
						<p>
							Please see {{ customData.provenance }}’s
							<a class="fw-medium" routerLink="/privacy-policy"
								>Privacy Policy</a
							>, for further details regarding your information. Please note, as
							set forth in the Privacy Policy, that
							{{ customData.provenance }}.com may collect certain User
							information and may contact Users periodically in accordance with
							the terms of the Privacy Policy. In addition,
							{{ customData.provenance }} reserves the right to comply, in its
							sole discretion, with legal requirements, requests from law
							enforcement agencies or requests from government entities, even to
							the extent that such compliance may require disclosure of certain
							User information. In addition, third parties may retain cached
							copies of User information.
						</p>
					</li>
					<li>
						<p>
							To maintain the quality of the Website and Services,
							{{ customData.provenance }} in its sole discretion may impose
							limits on your ability to apply to job listings or the Services.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} reserves the right to limit your
							ability to set your Profile, at any time, to prevent illegal
							conduct, for fraud, or any other reasons at
							{{ customData.provenance }}'s discretion.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may use your Profile and any other
							information you provide to improve the Website or the Service
							including how the Content is presented.
						</p>
					</li>
					<li>
						<p>
							By creating your Profile on the Website,
							{{ customData.provenance }} may share with you available job
							postings that {{ customData.provenance }} in its discretion sees
							to match your Profile.
						</p>
					</li>
					<li>
						<p>
							When searching for job matches, {{ customData.provenance }} may
							suggest information to include in your Profile in order to improve
							your search.
						</p>
					</li>
					<li>
						<p>
							You understand and agree that {{ customData.provenance }} has no
							obligation to present you with any or all job matches.
						</p>
					</li>
					<li>
						<p>
							You understand and acknowledge that you have no ownership rights
							in your account and that if you cancel your Account or your
							Account is terminated, all your account information from Database
							or Website, including your Profile will remain in the Database at
							the discretion of {{ customData.provenance }}. In addition, the
							Employees and/or the Clients may retain saved copies of your
							information or Profile.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} reserves the right to delete your
							account and all of your information after a significant duration
							of inactivity.
						</p>
					</li>
					<li>
						<p>
							You understand and agree that {{ customData.provenance }} cannot
							guarantee that the Client will consider your application or make
							particular determination with regard to your application.
							Ultimately, {{ customData.provenance }} will decide on your
							suitability as a Candidate for potential employment at
							{{ customData.provenance }}.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">User Content and Submissions</p>
				<ol type="a">
					<li>
						<p>
							You understand that all User Content is the sole responsibility of
							the person from which such User Content originated.
						</p>
					</li>
					<li>
						<p>
							You understand and acknowledge that all information provided by
							you, your {{ customData.url }} Profile, resume, and/or account
							information shall be stored in {{ customData.url }} Databases
							and/or {{ customData.url }} Website.
						</p>
					</li>
					<li>
						<p>
							You understand, acknowledge and consent that all information
							provided by you, your {{ customData.url }} Profile, resume, and/or
							account information may be transferred to countries outside of
							your location for the purposes of storing and/or processing.
							Please see {{ customData.provenance }}’s
							<a class="fw-medium" routerLink="/privacy-policy"
								>Privacy Policy</a
							>, for further details.
						</p>
					</li>
					<li>
						<p>
							By submitting, posting or displaying User Content on or through
							{{ customData.url }} Website, you grant {{ customData.url }},
							subject to your privacy setting, a worldwide, non-exclusive,
							royalty-free license to reproduce, adapt, distribute and publish
							such User Content through {{ customData.url }} Website.
							{{ customData.provenance }} will discontinue this licensed use
							within a reasonable period after such User Content is removed from
							{{ customData.url }} Website.{{ customData.provenance }} reserves
							the right to refuse to accept, post, display or transmit any User
							Content in its sole discretion.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} may review and remove any User Content
							that, in its sole judgment, violates these Terms, violates
							applicable laws, rules or regulations, is abusive, disruptive,
							offensive or illegal, or violates the rights of, or harms or
							threatens the safety of, Users of any
							{{ customData.url }} Website. {{ customData.provenance }} reserves
							the right to expel Users and prevent their further access to the
							{{ customData.url }} Website and/or use of
							{{ customData.url }} Services for violating the Terms or
							applicable laws, rules or regulations.
							{{ customData.provenance }} may take any action with respect to
							User Content that it deems necessary or appropriate in its sole
							discretion if it believes that such User Content could create
							liability for {{ customData.provenance }}, damage
							{{ customData.provenance }}’s brand or public image, or cause
							{{ customData.provenance }} to lose Users.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} does not represent or guarantee the
							truthfulness, accuracy, or reliability of User Content, derivative
							works from User Content, or any other communications posted by
							Users nor does {{ customData.provenance }} endorse any opinions
							expressed by Users. You acknowledge that any reliance on material
							posted by other Users will be at your own risk.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">
					{{ customData.provenance }}’s Right to Suspend or Cancel Your
					Registration
				</p>
				<ol type="a">
					<li>
						<p>
							We may suspend or cancel your registration immediately at our
							reasonable discretion or if you breach any of your obligations
							under these Terms.
						</p>
					</li>
					<li>
						<p>
							You can cancel your registration at any time by informing us in
							writing. If you do so, you must stop using the
							{{ customData.url }}
							Website.
						</p>
					</li>
					<li>
						<p>
							The suspension or cancellation of your registration and your right
							to use the {{ customData.url }} Website shall not affect either
							party’s statutory rights or liabilities.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Term and Termination</p>
				<ol type="a">
					<li>
						<p>
							These Terms will remain in full force and effect while you are a
							user of any {{ customData.url }} Website.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} reserves the right, at its sole
							discretion, to pursue all of its legal remedies, including but not
							limited to removal of your User Content from the
							{{ customData.url }} Website and immediate termination of your
							registration with or ability to access the
							{{ customData.url }} Website and/or any other services provided to
							you by {{ customData.provenance }}, upon any breach by you of
							these Terms or if {{ customData.provenance }} is unable to verify
							or authenticate any information you submit to a
							{{ customData.url }} Website registration.
						</p>
					</li>
					<li>
						<p>
							Even after you are no longer a User of the {{ customData.url }}
							Website, certain provisions of these Terms will remain in effect,
							including Sections 5, 14, 15, 16 and 18, inclusive.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">{{ customData.provenance }}’s Liability</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.url }} Website acts, among other things, venues for:
						</p>
						<ol type="i">
							<li>
								<p>
									Employees to search for and evaluate jobs candidates for
									Client referral or {{ customData.provenance }} employment;
								</p>
							</li>
							<li>
								<p>
									Clients or their agents/employees to search for and evaluate
									job Candidates;
								</p>
							</li>
							<li>
								<p>
									Candidates to post {{ customData.url }} Profiles and resumes
									and search for and evaluate job opportunities; and
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							{{ customData.provenance }} does not screen or censor the
							listings, including {{ customData.url }} Profiles offered. As a
							result, {{ customData.provenance }} is not responsible for User
							Content, the quality, safety or legality of the resumes posted,
							the truth or accuracy of the listings, or the ability of
							candidates to fill job openings and {{ customData.provenance }}
							makes no representations about any jobs,
							{{ customData.url }} Profiles, resumes or User Content on the
							{{ customData.url }}
							Website.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} reserves the right in its sole
							discretion to remove any User Content including but not limited to
							{{ customData.url }} Profiles or other material from the
							{{ customData.url }} Website from time to time. When
							{{ customData.provenance }} exercises this discretion and there is
							a breach of these Terms by the User,
							{{ customData.provenance }} reserves its right to institute any
							actions against the User.
						</p>
					</li>
					<li>
						<p>
							Note that there are risks, including but not limited to the risk
							of physical harm, of dealing with strangers, underage persons or
							people acting under false pretenses. You assume all risks
							associated with dealing with other users with whom you come in
							contact through the {{ customData.url }} Website. By its very
							nature other people’s information may be offensive, harmful or
							inaccurate, and in some cases will be mislabeled or deceptively
							labeled. We expect that you will use caution and common sense when
							using the {{ customData.url }} Website.
						</p>
					</li>
					<li>
						<p>
							The {{ customData.url }} Website and the {{ customData.url }}
							Content may contain inaccuracies or typographical errors.
							{{ customData.provenance }} makes no representations about the
							accuracy, reliability, completeness, or timeliness of any
							{{ customData.url }} Website or the {{ customData.url }} Content.
							The use of all {{ customData.url }} Website and the
							{{ customData.url }} Content is at your own risk.
						</p>
					</li>
					<li>
						<p>
							Nothing on {{ customData.url }} Website shall be considered an
							endorsement, representation or warranty with respect to any User
							or third party, whether in regards to its web sites, products,
							services, hiring, experience, employment or recruiting practices,
							or otherwise.
						</p>
					</li>
					<li>
						<p>
							If we are in breach of these Terms, we will only be responsible
							for any losses that you suffer as a direct result and to the
							extent that they are a foreseeable consequence to both of us at
							the time you use the {{ customData.url }} Website. Our liability
							shall not in any event include business losses such as lost data,
							lost profits or business interruption.
						</p>
					</li>
					<li>
						<p>
							The aggregate liability by {{ customData.provenance }} to you for
							all claims arising from your use of {{ customData.url }} Website
							and/or {{ customData.url }} Services shall be limited to the
							Liability Clause in your Services Agreement for the Client, or in
							the event you are a Candidate, shall be limited to
							<span class="fw-medium">AUD$35</span>.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Disclaimers</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} shall not be liable for any loss of
							information however caused as a result of any interruption,
							suspension or termination of the Website or for the Content,
							accuracy or quality of information available or transmitted
							through the Services.
						</p>
					</li>
					<li>
						<p>
							You acknowledge and agree that it is not
							{{ customData.provenance }}’s policy to exercise editorial control
							over and to edit or amend any data or contents of any emails or
							posting or any information that may be inserted or made available
							or transmitted to or from a third party in or through the Website
							and/or the Services.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Third Party Website</p>
				<ol type="a">
					<li>
						<p>
							{{ customData.provenance }} is not responsible for content on any
							site outside the {{ customData.url }} Website.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Indemnity</p>
				<ol type="a">
					<li>
						<p>
							You agree to defend, indemnify, and hold harmless
							{{ customData.provenance }}, and its affiliates, and their
							respective officers, directors, employees, and agents, from and
							against any claims, actions or demands, including without
							limitation reasonable legal and accounting fees, alleging or
							resulting from:
						</p>
						<ol type="i">
							<li>
								<p>
									any User Content or other material you provide to the Website;
								</p>
							</li>
							<li>
								<p>Your use of any of the Content; or</p>
							</li>
							<li>
								<p>Your breach of these Terms.</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							{{ customData.provenance }} shall provide notice to you promptly
							of any such claim, suit or proceeding.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Applicable Law and Jurisdiction</p>
				<ol type="a">
					<li>
						<p>
							These Terms and any dispute arising out of or in connection with
							this Agreement or related in any way to the Website will be
							subject to the laws and courts, to wit:
						</p>
						<ol type="i">
							<li>
								<p>
									Delaware, USA if you are located in USA and any of its
									territories;
								</p>
							</li>
							<li>
								<p>
									Angeles City, Philippines if you are located in the
									Philippines;
								</p>
							</li>
							<li>
								<p>
									New South Wales, Australia if you are located in Australia or
									elsewhere.
								</p>
							</li>
						</ol>
					</li>
					<li>
						<p>
							We will try to solve any disagreements quickly and efficiently. If
							you are not happy with the way we deal with any disagreement and
							you want to take court proceedings, you must do so within the
							applicable law and jurisdiction above-mentioned.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">International Use</p>
				<ol type="a">
					<li>
						<p>
							We make no promise that materials on the Website are appropriate
							or available for use in your location, and accessing the Website
							from territories where its contents are illegal or unlawful is
							prohibited. If you choose to access this Website from your
							location, you do so on your own initiative and are responsible for
							compliance with local laws.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">Miscellaneous</p>
				<ol type="a">
					<li>
						<p>
							You may not transfer any of your rights under these Terms to any
							other person. We may transfer our rights under these Terms to
							another business where we reasonably believe your rights will not
							be affected.
						</p>
					</li>
					<li>
						<p>
							If you breach these Terms and {{ customData.provenance }} chooses
							to ignore this, {{ customData.provenance }} will still be entitled
							to use its rights and remedies at a later date or in any other
							situation where you breach the Terms.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} shall not be responsible for any
							breach of these Terms caused by circumstances beyond its
							reasonable control.
						</p>
					</li>
					<li>
						<p>
							If any of these Terms shall be found by any court or
							administrative body of competent jurisdiction to be invalid or
							unenforceable, the invalidity or unenforceability of such
							provision shall not affect the other provisions of these Terms and
							all provision not affected by such invalidity or unenforceability
							shall remain in full force and effect.
						</p>
					</li>
					<li>
						<p>
							{{ customData.provenance }} has taken every reasonable step to
							comply and will continue to comply with its obligations as a data
							processor arising from the data protection and privacy laws in
							force from time to time to the extent that those obligations are
							relevant to this Agreement. Further, we have taken steps to
							implement and shall maintain an information security program
							including reasonable administrative, technical and physical
							measures designed to secure and protect the confidentiality,
							integrity and availability of all Confidential Information while
							in such party’s possession against unauthorized, unlawful or
							accidental access, disclosure, transfer, destruction, loss or
							alteration. The term Confidential Information will not, however,
							include any information that identifies or directly relates to
							natural persons (“Personal Data”). Each party will exercise
							commercially reasonable efforts not to disclose any Personal Data
							to the other party and to restrict the other party’s access to its
							Personal Data, but if a party is given access to the other party’s
							Personal Data, the receiving party will protect such Personal Data
							using a reasonable standard of care.
						</p>
					</li>
				</ol>
			</li>
			<li>
				<p class="fw-bold">General</p>
				<ol type="a">
					<li>
						<p>
							The Website is owned and operated by {{ customData.provenance }}.
						</p>
					</li>
					<li>
						<p>
							If you have any queries please contact us
							<a class="fw-medium" [href]="customData.mailToRecruiterEmail">{{
								customData.recruitEmail
							}}</a>
						</p>
					</li>
					<li>
						<p>
							We will send notice to you at the address submitted by you or to
							such other address as {{ customData.provenance }} reasonably
							determines is an appropriate address for you.
						</p>
					</li>
				</ol>
			</li>
		</ol>
	</div>
</div>
